import { JsonObject } from 'ta-json';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_configuratorIcons,
} from '@src/app/generated/GetAllRetailers';
import { PortalAsset } from '@src/app/model/portal-asset';
import { ConfiguratorIconsInput } from '@src/app/generated/globalTypes';
import { ConfiguratorIcons } from '@ess/jg-rule-executor/dist/src/domain/configurator-icons';

/**
 * Font
 */
@JsonObject()
export class PortalConfigurationIcons extends ConfiguratorIcons {
  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_configuratorIcons
  ): PortalConfigurationIcons {
    return new PortalConfigurationIcons(
      gql.measurement ? PortalAsset.fromGql(gql.measurement) : undefined,
      gql.woodType ? PortalAsset.fromGql(gql.woodType) : undefined,
      gql.reset ? PortalAsset.fromGql(gql.reset) : undefined
    );
  }

  public toGqlInput(): ConfiguratorIconsInput {
    return {
      measurement: (this.measurement as PortalAsset)?.toGqlInput(),
      woodType: (this.woodType as PortalAsset)?.toGqlInput(),
      reset: (this.reset as PortalAsset)?.toGqlInput(),
    };
  }
}
